import React from 'react';
import MeetOurDentistsSection from './Section';
import Doctors from './Doctors';

var MeetOurDentistsTemplate = function MeetOurDentistsTemplate(_ref) {
  var doctors = _ref.doctors,
      sectionBackground = _ref.sectionBackground,
      sectionDescription = _ref.sectionDescription,
      _ref$sectionInfoAlign = _ref.sectionInfoAlignment,
      sectionInfoAlignment = _ref$sectionInfoAlign === void 0 ? 'center' : _ref$sectionInfoAlign,
      title = _ref.title;
  return React.createElement(React.Fragment, null, Array.isArray(doctors) && doctors.length > 0 && React.createElement(MeetOurDentistsSection, {
    title: title,
    sectionBackground: sectionBackground,
    sectionInfoAlignment: sectionInfoAlignment,
    description: sectionDescription
  }, React.createElement(Doctors, {
    doctors: doctors
  })));
};

export default MeetOurDentistsTemplate;